var BaseLayout = require("enyo/Layout"),
    Layout,
    kind       = require("enyo/kind"),
    utils      = require("enyo/utils");

require("enyo-ui");

/**
 * An extension of Enyo's default Layout that allows providing a default
 * `options` hash on the Layout kind itself and a `layoutOptions` hash on the
 * container Component to override the defaults.
 *
 * When extending a layout, the default options are inherited from the parent
 * kind and options defined on the sub-kind will be mixed in. If parent kind and
 * sub-kind have options of the same name, the sub-kind's option will be used.
 *
 * @ui
 * @class enyo-ui.Layout
 * @public
 */
Layout = module.exports = kind(/** @lends  enyo-ui.Layout.prototype */ {

    /**
     * @private
     */
    name: "enyo-ui.Layout",

    /**
     * @private
     */
    kind: BaseLayout,

    /**
     * Default options for the layout.
     *
     * @type {Object}
     * @protected
     */
    options: null,

    /**
     * Imports layoutOptions from container.
     *
     * @param {enyo.Control}  container  The container
     * @private
     */
    constructor: kind.inherit(function(sup) {
        return function(container) {
            sup.apply(this, arguments);

            if (container) {
                this.options = utils.mixin(utils.clone(this.options || {}), container.layoutOptions);
            }
        };
    }),

    /**
     * Convenience method for retrieving options, automatically resolves
     * computed options.
     *
     * @param  {string}  option  The option
     * @return {*}       The option's value
     * @public
     */
    getOption: function(option) {
        var value;

        value = this.options[option];

        return utils.isFunction(value) ? value.call(this) : value;
    }

});

/**
 * This method allows enyo.kind to extend the options hash when creating super
 * kinds.
 *
 * @param    {Function}  ctor   The constructor
 * @param    {Object}    props  The properties
 * @memberof enyo-ui.Layout
 * @static
 * @private
 */
Layout.concat = function(ctor, props) {
    var proto = ctor.prototype || ctor,
        options;

    if (props.options) {
        options       = proto.options ? utils.clone(proto.options) : {};
        proto.options = utils.mixin(options, props.options);
        delete props.options;
    }
};
